import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { MonogramPattern } from '../brand/MonogramPattern';
import { ButtonLink } from '../ui/ButtonLink';
import { images } from '../../data/images';
import { audienceLinks } from '../../data/audiences';
import { discussSearchHref } from '../../data/navigation';
export function HomeHero() {
  return <section className="relative overflow-hidden bg-navy" aria-labelledby="hero-title" data-id="element-160" data-mp="2wtlizdqqn9j0">
      <MonogramPattern className="pointer-events-none absolute -left-48 -top-10 hidden h-[115%] text-gold opacity-[0.1] lg:block" data-id="element-161" data-mp="31sye0lrrjmwo" />
      <div className="relative mx-auto grid max-w-7xl gap-14 px-5 pb-16 pt-14 sm:px-8 lg:grid-cols-12 lg:gap-10 lg:pb-24 lg:pt-20" data-id="element-162" data-mp="2n3ag7uisj6dp">
        <div className="lg:col-span-6 lg:self-center lg:pr-6" data-id="element-163" data-mp="2s1bve4d3iljw">
          <p className="av-enter flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.2em] text-gold" style={{
          animationDelay: '60ms'
        }} data-id="element-164" data-mp="3fry1vr7gbxrs">
            <span aria-hidden="true" className="h-px w-8 bg-gold" data-id="element-165" data-mp="oufsyrydwmka" />
            Exceptional Talent. Strategic Leadership.
          </p>
          <h1 id="hero-title" className="av-enter mt-7 font-serif text-[2.9rem] font-medium leading-[1.03] text-white sm:text-6xl xl:text-[4.6rem]" style={{
          animationDelay: '140ms'
        }} data-id="element-166" data-mp="jxz41vjd2465">
            Connecting Exceptional Talent with Strategic Opportunity.
          </h1>
          <p className="av-enter mt-7 max-w-xl text-lg leading-relaxed text-white/75" style={{
          animationDelay: '220ms'
        }} data-id="element-167" data-mp="17njnefjff3fy">
            Avenqor Talent Search approaches executive search and talent engagement with research, discretion, and a
            focus on the leadership and professional capabilities organizations need.
          </p>
          <div className="mt-10 flex flex-col gap-3 sm:flex-row" data-id="element-168" data-mp="3ie9ztrpyjpu3">
            <div className="av-enter" style={{
            animationDelay: '300ms'
          }} data-id="element-169" data-mp="3ecyalnazx6mf">
              <ButtonLink to={discussSearchHref} variant="gold" className="w-full sm:w-auto" data-id="element-170" data-mp="1hbsdd41tow6e">
                Discuss a Search
              </ButtonLink>
            </div>
            <div className="av-enter" style={{
            animationDelay: '370ms'
          }} data-id="element-171" data-mp="1mcpuref0dm6u">
              <ButtonLink to="#approach" inPage variant="outlineLight" className="w-full sm:w-auto" data-id="element-172" data-mp="1r855vylmt3zk">
                Explore Our Approach
              </ButtonLink>
            </div>
          </div>
        </div>

        <div className="av-enter-image relative lg:col-span-6" style={{
        animationDelay: '180ms'
      }} data-id="element-173" data-mp="20a4ouwg7ii55">
          <div aria-hidden="true" className="absolute -right-3 -top-3 hidden h-full w-full border border-gold/40 sm:block lg:-right-5 lg:-top-5" data-id="element-174" data-mp="257of6uq6ildg" />
          <img src={images.heroBoardroom.src} alt={images.heroBoardroom.alt} width={928} height={1152} className="relative aspect-[4/3] w-full object-cover object-[center_35%] lg:aspect-[5/6]" data-id="element-175" data-mp="2exzjwjhosyle" />
        </div>
      </div>

      <div className="relative border-t border-white/10" data-id="element-176" data-mp="cdop10z77xeo">
        <ul className="mx-auto grid max-w-7xl px-5 sm:grid-cols-3 sm:px-8" data-id="element-177" data-mp="8b1wexupe8gf">
          {audienceLinks.map((item, index) => <li key={item.to} className={`border-white/10 ${index > 0 ? 'border-t sm:border-l sm:border-t-0' : ''}`} data-id="element-178" data-mp="3b5seym0ah0v" data-mpi={index}>
              <Link to={item.to} className={`group flex items-center justify-between gap-4 py-6 ${index > 0 ? 'sm:pl-8' : ''} sm:pr-8`} data-id="element-179" data-mp="3ukla4rlo45zr">
                <span data-id="element-180" data-mp="r3mkm1zgjpdw">
                  <span className="block text-xs font-semibold uppercase tracking-[0.16em] text-gold" data-id="element-181" data-mp="matfhd02uf1a">
                    {item.audience}
                  </span>
                  <span className="mt-1.5 block text-[15px] text-white transition-colors duration-200 ease-out group-hover:text-gold-light" data-id="element-182" data-mp="hbgja1nbfvm1">
                    {item.label}
                  </span>
                </span>
                <ArrowRightIcon className="h-4 w-4 shrink-0 text-white/50 transition-[transform,color] duration-200 ease-out group-hover:translate-x-0.5 group-hover:text-gold" aria-hidden="true" data-id="element-183" data-mp="19ykqmd9vsm0z" />
              </Link>
            </li>)}
        </ul>
      </div>
    </section>;
}